const systemSetup = () => import('../view/systemSetup/index')
//品牌
const brandSet = () => import('../view/systemSetup/brandSet')
// 企业
const companySet = () => import('../view/systemSetup/companySet')
// 权限
const permissionSet = () => import('../view/systemSetup/permissionSet')
//路径配置
const pathSet = () => import('../view/systemSetup/pathSet')
//规则配置
const ruleSet = () => import('../view/systemSetup/ruleSet')
// 应用市场
const appStore = () => import('../view/systemSetup/appStore')
// 工单提交
const workOrder = () => import('../view/systemSetup/workOrder')
// 使用手册
const useBook = () => import('../view/systemSetup/useBook')
//权限管理页面跳转新增管理员
const addAdmin = () => import('../view/systemSetup/components/permissionCom/addAdmin')
//企业配置跳转短线模板 
const messageTemplate = () => import('../view/systemSetup/components/companyCom/messageTemplate')
//企业配置跳转短信签名 
const messageSignatures = () => import('../view/systemSetup/components/companyCom/messageSignatures')

const router = [
    {
        path: '/systemSetup',
        component: systemSetup,
        name: 'systemSetup',
        redirect: '/systemSetup/brandSet',
        meta: {
            menuTitle: "系统管理",
            menuKey: "systemSetup",
            menuIcon: "icon-system",
        },
        children: [
            {
                path: 'basicsSet',
                component: systemSetup,
                name: 'basicsSet',
                redirect: '/systemSetup/brandSet',
                meta: {
                    menuTitle: "基础设置",
                    menuKey: "systemSetup",
                    menuIcon: "icon-basics-set",
                },
                children:[
                    {
                        path:"/systemSetup/brandSet", 
                        component:brandSet,
                        name:'brandSet',
                        meta:{
                            menuKey:"systemSetup",
                            menuTitle: "品牌配置",
                            menuIcon: "el-icon-chat-dot-round",
                          }
                    },
                    {
                        path:"/systemSetup/companySet", 
                        component:companySet,
                        name:'companySet',
                        meta:{
                            menuKey:"systemSetup",
                            menuTitle: "企业配置",
                            menuIcon: "el-icon-chat-dot-round",
                          }
                    },
                    
                    {
                        //企业配置跳短信模板
                        path:"/systemSetup/messageTemplate", 
                        component:messageTemplate,
                        name:'messageTemplate',
                        meta:{
                            menuKey:"systemSetup",
                            secondMenuKey: 'companySet'
                          }
                    },
                    {
                        //企业配置跳短信签名
                        path:"/systemSetup/messageSignatures", 
                        component:messageSignatures,
                        name:'messageSignatures',
                        meta:{
                            menuKey:"systemSetup",
                            secondMenuKey: 'companySet'
                          }
                    },
                    {
                        path:"/systemSetup/permissionSet", 
                        component:permissionSet,
                        name:'permissionSet',
                        meta:{
                            menuKey:"systemSetup",
                            menuTitle: "权限配置",
                            menuIcon: "el-icon-chat-dot-round",
                          }
                    },
                    {
                        path:"/systemSetup/pathSet", 
                        component:pathSet,
                        name:'pathSet',
                        meta:{
                            menuKey:"systemSetup",
                            menuTitle: "路径配置",
                            menuIcon: "el-icon-chat-dot-round",
                          }
                    },
                    {
                        path:"/systemSetup/ruleSet", 
                        component:ruleSet,
                        name:'ruleSet',
                        meta:{
                            menuKey:"systemSetup",
                            menuTitle: "规则配置",
                            menuIcon: "el-icon-chat-dot-round",
                          }
                    },
                    {
                        // 新增管理员
                        path:"/systemSetup/addAdmin", 
                        component:addAdmin,
                        name:'addAdmin',
                        meta:{
                            menuKey:"systemSetup",
                            secondMenuKey: 'permissionSet'
                          }
                    }

                ]
            },
            {
                path: 'appreciation',
                component: systemSetup,
                name: 'appreciation',
                meta: {
                    menuTitle: "增值应用",
                    menuKey: "systemSetup",
                    menuIcon: "icon-appreciation-app",
                },
                children:[
                    {
                        path:"/systemSetup/appStore", 
                        component:appStore,
                        name:'appStore',
                        meta:{
                            menuKey:"systemSetup",
                            menuTitle: "应用市场",
                            menuIcon: "el-icon-chat-dot-round",
                          }
                    },
                    {
                        path:"/systemSetup/workOrder", 
                        component:workOrder,
                        name:'workOrder',
                        meta:{
                            menuKey:"systemSetup",
                            menuTitle: "工单提交",
                            menuIcon: "el-icon-chat-dot-round",
                          }
                    },
                    {
                        path:"/systemSetup/useBook", 
                        component:useBook,
                        name:'useBook',
                        meta:{
                            menuKey:"systemSetup",
                            menuTitle: "使用手册",
                            menuIcon: "el-icon-chat-dot-round",
                          }
                    },
                ]
            }

        ]
    }
]
export default router